import {
  bitlyTip,
  byinteraInTip,
  vagasEmbTip,
} from "../../services/FieldsTips";
import { convertToVagas } from "../../services/helpers";
import CopiableUrl from "../CopiableURL";
import InfoTooltip from "./InfoTooltip";

function ShortenedLinks(props) {
  const { hasError, errorMessage } = props.error;
  const { bitlyLink, byInteraInLink, longUrl } = props.links;

  return (
    <>
      {hasError && (
        <ul className="ul-messages">
          <li className="invalid ul-message" key={errorMessage}>
            {errorMessage}
          </li>
        </ul>
      )}

      {<CopiableUrl url={longUrl} text={"URL longa"}></CopiableUrl>}

      {!!bitlyLink && (
        <div className="bitilink">
          <CopiableUrl url={bitlyLink} text={bitlyLink}></CopiableUrl>
          <InfoTooltip tipsInfo={[bitlyTip]} />
        </div>
      )}

      {!!byInteraInLink && (
        <>
          <div className="bitilink">
            <CopiableUrl
              url={byInteraInLink}
              text={byInteraInLink}
            ></CopiableUrl>
            <InfoTooltip tipsInfo={[byinteraInTip]} />
          </div>

          <div className="bitilink">
            <CopiableUrl
              url={convertToVagas(byInteraInLink)}
              text={convertToVagas(byInteraInLink)}
            ></CopiableUrl>
            <InfoTooltip tipsInfo={[vagasEmbTip]} />
          </div>
        </>
      )}
    </>
  );
}

export default ShortenedLinks;
